import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ROLE_LABELS } from "@/lib/nav";
import { History } from "lucide-react";

export default function ActivityPage() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/activity-logs");
        if (!cancelled) setLogs(data);
      } catch (err) {
        console.error("Failed to load activity logs", err);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="space-y-5 fade-up" data-testid="activity-page">
      <div><h1 className="text-3xl font-bold tracking-tight">Activity Logs</h1>
        <p className="text-sm text-muted-foreground mt-1">{logs.length} entries (latest 300)</p></div>

      <Card>
        <CardContent className="p-0">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-xs uppercase tracking-wider text-muted-foreground border-b border-border">
              <th className="py-3 px-5">When</th><th>User</th><th>Action</th><th>Resource</th><th className="px-5">Meta</th>
            </tr></thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id} className="border-b border-border last:border-0 hover:bg-muted/40">
                  <td className="py-2.5 px-5 mono text-xs text-muted-foreground">{new Date(l.timestamp).toLocaleString()}</td>
                  <td>
                    <div className="font-medium">{l.user_name}</div>
                    <div className="text-[10px] text-muted-foreground">{ROLE_LABELS[l.user_role]}</div>
                  </td>
                  <td><Badge variant="outline" className="text-[10px]">{l.action}</Badge></td>
                  <td className="text-muted-foreground">{l.resource}</td>
                  <td className="px-5 mono text-[10px] text-muted-foreground truncate max-w-[200px]">{Object.keys(l.meta || {}).length ? JSON.stringify(l.meta) : "—"}</td>
                </tr>
              ))}
              {logs.length === 0 && <tr><td colSpan="5" className="py-10 text-center text-muted-foreground">No activity yet.</td></tr>}
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>
  );
}
